import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import Styles from './vm-dropdown.scss';

/**
 * A styled menu list for vm-dropdown-item elements.
 * Typically used as content inside a vm-popover.
 *
 * @slot - Default slot for vm-dropdown-item elements.
 *
 * @example
 * ```html
 * <vm-dropdown>
 *   <vm-dropdown-item group>
 *     Save to
 *     <vm-dropdown-item groupitem slot="children">LinkedIn</vm-dropdown-item>
 *     <vm-dropdown-item groupitem slot="children">Youtube</vm-dropdown-item>
 *   </vm-dropdown-item>
 *   <vm-dropdown-item>Create new playlist</vm-dropdown-item>
 * </vm-dropdown>
 * ```
 */
@customElement('vm-dropdown')
export class VmDropdown extends LitElement {
    static override styles = Styles;

    override connectedCallback() {
        super.connectedCallback();
        this.classList.add('vm-dropdown');
        this.dataset.testid = 'vm-dropdown';
        this.setAttribute('role', 'menu');
        this.addEventListener('vm-dropdown-item-click', this._onItemClick);
    }

    override disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('vm-dropdown-item-click', this._onItemClick);
    }

    /** Re-dispatches item click as a generic vm-popover-close event. */
    private _onItemClick = () => {
        this.dispatchEvent(
            new CustomEvent('vm-popover-close', {
                bubbles: true,
                composed: true,
            }),
        );
    };

    override render() {
        return html`<slot></slot>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-dropdown': VmDropdown;
    }
}
